import {create} from 'zustand';
export const useEventsStore = create((set) => ({
    events: null,
    event: null,
    setEvents: (events) => {
        events?.forEach((event, key) => {
            const month = event.date_start.substring(0, 7);
            let name = (new Date(event.date_start)).toLocaleString('default', {month: 'long'}) + " " + event.date_start.substring(0, 4);
            name = String(name).charAt(0).toUpperCase() + String(name).slice(1);
            events[key].month = month;
            events[key].monthName = name;
            events[key].sameDay = event.date_start.substring(0, 9) === event.date_end.substring(0, 9);
        })
        return set({ events })
    },
    setEvent: (event) => {

        const month = event.date_start.substring(0, 7);
        let name = (new Date(event.date_start)).toLocaleString('default', {month: 'long'}) + " " + event.date_start.substring(0, 4);
        name = String(name).charAt(0).toUpperCase() + String(name).slice(1);
        event.month = month;
        event.monthName = name;
        event.sameDay = event.date_start.substring(0, 9) === event.date_end.substring(0, 9);

        set({ event })
    },
}));